import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
import { isBrowserScope } from '../../../common/constants/runtime';
import { handle } from '../../../common/event-emitter/handle';
import { windowAddEventListener } from '../../../common/event-listener/event-listener-opts';
import { InstrumentBase } from '../../utils/instrument-base';
import { FEATURE_NAME, OBSERVED_EVENTS, OBSERVED_WINDOW_EVENTS } from '../constants';
export var Instrument = /*#__PURE__*/function (_InstrumentBase) {
  _inherits(Instrument, _InstrumentBase);

  var _super = _createSuper(Instrument);

  function Instrument(agentRef) {
    var _this;

    var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, agentRef, FEATURE_NAME, auto);
    var genericEventSourceConfigs = [agentRef.init.page_action.enabled, agentRef.init.performance.capture_marks, agentRef.init.performance.capture_measures, agentRef.init.user_actions.enabled // other future generic event source configs to go here, like M&Ms, PageResouce, etc.
    ];

    if (isBrowserScope && agentRef.init.user_actions.enabled) {
      OBSERVED_EVENTS.forEach(function (eventType) {
        return windowAddEventListener(eventType, function (evt) {
          return handle('ua', [evt], undefined, _this.featureName, _this.ee);
        }, true);
      });
      OBSERVED_WINDOW_EVENTS.forEach(function (eventType) {
        return windowAddEventListener(eventType, function (evt) {
          return handle('ua', [evt], undefined, _this.featureName, _this.ee);
        });
      } // Capture is not used here so that we don't get element focus/blur events, only the window's as they do not bubble. They are also not cancellable, so no worries about being front of line.
      );
    }
    /** If any of the sources are active, import the aggregator. otherwise deregister */


    if (genericEventSourceConfigs.some(function (x) {
      return x;
    })) _this.importAggregator(agentRef);else _this.deregisterDrain();
    return _this;
  }

  return _createClass(Instrument);
}(InstrumentBase);

_defineProperty(Instrument, "featureName", FEATURE_NAME);

export var GenericEvents = Instrument;